import { render, staticRenderFns } from "./guest-registration-header.vue?vue&type=template&id=6f7acfbe&"
import script from "./guest-registration-header.vue?vue&type=script&lang=ts&"
export * from "./guest-registration-header.vue?vue&type=script&lang=ts&"
import style0 from "./guest-registration-header.vue?vue&type=style&index=0&id=6f7acfbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports